import React, { useState } from "react";
import { connect } from "react-redux";
import "../assets/css/login.css";
import { loginAdmin } from "../store/Admin/admin.action";
import logo from "../assets/img/logo.png";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState({});
  const [busy, setBusy] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    const err = {};
    if (!email) err.email = "E-posta adresini yaz.";
    else if (!EMAIL_RE.test(email)) err.email = "Geçerli bir e-posta adresi yaz.";
    if (!password) err.password = "Şifreni yaz.";
    setError(err);
    if (Object.keys(err).length) return;
    setBusy(true);
    props.loginAdmin({ email: email.trim(), password });
    setTimeout(() => setBusy(false), 2500);
  };

  return (
    <div className="bl-login">
      <aside className="bl-brand">
        <div className="bl-mark">
          <img src={logo} alt="" draggable="false" />
          <div>
            <b>AYVO</b>
            <span>Yönetim Paneli</span>
          </div>
        </div>

        <div className="bl-hero">
          <h1>
            Platformun tamamı <em>tek ekranda.</em>
          </h1>
          <p>Yayıncıları, sesli odaları, ajansları ve coin hareketlerini buradan yönet.</p>
          <ul className="bl-points">
            <li>
              <i>●</i> Canlı yayın ve PK düelloları anlık takip
            </li>
            <li>
              <i>◆</i> Yetkili Bayi: bayi stoğu ve gönderim kayıtları
            </li>
            <li>
              <i>✓</i> Şikayet, engelleme ve yaş denetimi
            </li>
          </ul>
        </div>

        <div className="bl-foot">© {new Date().getFullYear()} AYVO · admin.badulive.online</div>
      </aside>

      <main className="bl-panel">
        <form className="bl-card" onSubmit={handleSubmit} noValidate>
          <h2>Giriş yap</h2>
          <p className="bl-lead">Yönetici hesabınla devam et.</p>

          <div className="bl-field">
            <label htmlFor="bl-email">E-posta</label>
            <div className={`bl-input ${error.email ? "bl-err" : ""}`}>
              <input
                id="bl-email"
                type="email"
                autoComplete="username"
                placeholder="ad@badulive.online"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error.email) setError({ ...error, email: "" });
                }}
              />
            </div>
            {error.email && <span className="bl-msg">{error.email}</span>}
          </div>

          <div className="bl-field">
            <label htmlFor="bl-pass">Şifre</label>
            <div className={`bl-input ${error.password ? "bl-err" : ""}`}>
              <input
                id="bl-pass"
                type={show ? "text" : "password"}
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error.password) setError({ ...error, password: "" });
                }}
              />
              <button type="button" className="bl-eye" onClick={() => setShow(!show)} aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}>
                {show ? "Gizle" : "Göster"}
              </button>
            </div>
            {error.password && <span className="bl-msg">{error.password}</span>}
          </div>

          <button type="submit" className="bl-submit" disabled={busy}>
            {busy ? "Giriş yapılıyor…" : "Giriş yap"}
          </button>

          <div className="bl-secure">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Bağlantı şifreli. Oturumun bu tarayıcıda kalır.
          </div>
        </form>
      </main>
    </div>
  );
};

export default connect(null, { loginAdmin })(Login);
